import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Paragraph } from '@digdir/designsystemet-react';
import type { HmsReturned } from '../../../api/hms';

export const ReturnedAlert = ({ version, returned }: { version: number; returned: HmsReturned }): ReactElement => {
  const { t } = useTranslation();
  return (
    <Alert data-color="warning" data-size="sm">
      <Paragraph data-size="sm">{t('hms.returned', { version, comment: returned.comment })}</Paragraph>
    </Alert>
  );
};
